import React from "react";

const IconMyPosts = ({
  width = "19",
  height = "26",
  fill = "#000000",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 26"
      fill="none"
      className={className ? className : null}
      width={width}
      height={height}
      data-name="iconChat"
    >
      <rect x="1" y="1.50092" width="16.75" height="23" rx="1" stroke="black" strokeWidth="2"/>
      <rect x="2.50089" y="9.25" width="13.75" height="13.75" rx="1" fill="black"/>
      <rect x="2.50089" y="3.00183" width="13.75" height="1.25" rx="0.625" fill="black"/>
      <rect x="2.50089" y="5.5" width="8.75" height="1.25" rx="0.625" fill="black"/>
    </svg>
  );
};

export default IconMyPosts;
